import axios from 'axios'
import request from '@/utils/request'
import { Message } from 'element-ui'
import { saveAs } from 'file-saver'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { blobValidate } from "@/utils/weiming";

const baseURL = process.env.VUE_APP_BASE_API

export default {
  // 通用下载
  downloadFile(fileId) {
    request({
      url: '/basic/supplier/download',
      method: 'post',
      responseType: 'blob',
      data: { fileId }
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data]);
        this.saveAs(blob, decodeURI(res.headers['download-filename']));
      } else {
        this.printErrMsg(res.data);
      }
    }).catch((error) => {
      console.error('下载文件失败:', error);
      Message.error('下载文件失败，请稍后重试！');
    })
  },
  // 本地资源下载
  resource(resource) {
    var url = baseURL + "/common/download/resource?resource=" + encodeURI(resource);
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { Authorization: getToken() ? ('Bearer ' + getToken()) : "" }
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data])
        this.saveAs(blob, decodeURI(res.headers['download-filename']))
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  // 压缩包下载
  zip(url, name, method = 'post', data) {
    var url = baseURL + url
    axios({
      method,
      url: url,
      responseType: 'blob',
      headers: { Authorization: getToken() ? ('Bearer ' + getToken()) : "" },
      data
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data], { type: 'application/zip' })
        const tmp = res.headers['download-filename'] || name;
        this.saveAs(blob, decodeURI(tmp))
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  // 自定义下载
  customDownload(url, method, name, config) {
    // console.log('token', getToken())
    var url = baseURL + url
    axios({
      method,
      url: url,
      responseType: 'blob',
      ...config,
      headers: { Authorization: getToken() ? ('Bearer ' + getToken()) : "", ...config.headers },
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data])
        const tmp = res.headers['download-filename'] || name;
        this.saveAs(blob, decodeURI(tmp))
      } else {
        this.printErrMsg(res.data);
      }
    })
  },
  saveAs(text, name, opts) {
    saveAs(text, name, opts);
  },
  async printErrMsg(data) {
    const resText = await data.text();
    const rspObj = JSON.parse(resText);
    const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
    Message.error(errMsg);
  }
}

// 下载 base64
export function getFile(fileId) {
  var downloadUrl = baseURL + "/common/download";
  return axios({
    method: 'post',
    url: downloadUrl,
    responseType: 'blob',
    headers: { Authorization: getToken() ? ('Bearer ' + getToken()) : "" },
    data: { fileId }
  }).then(async (res) => {
    let base64Data = URL.createObjectURL(res.data);
    return base64Data
  }).catch((error) => {
    Message.error(error);
  })
}

// 预览文件 （支持多种格式）
export function previewFile(fileId, fileType) {
  if (!fileId) return;
  var downloadUrl = baseURL + "/common/download";
  return axios({
    method: 'post',
    url: downloadUrl,
    responseType: 'blob',
    headers: { Authorization: getToken() ? ('Bearer ' + getToken()) : "" },
    data: { fileId }
  }).then((res) => {
    const blobType = {
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      pdf: 'application/pdf',
      png: 'image/png',
      jpeg: 'image/jpeg',
      jpg: 'image/jpeg',
      zip: 'application/zip',
    }
    if (fileType === 'txt') {
      return new Promise((resolve) => {
        let reader = new FileReader();
        reader.readAsText(res.data, 'UTF-8');
        reader.onload = () => {
          resolve(reader.result)
        }
      })
    } else {
      const blob = new Blob([res.data], { type: `${blobType[fileType]};charset=utf-8` })
      const href = URL.createObjectURL(blob)
      return href
    }
  })
}